import { render, staticRenderFns } from "./ReportQuestionariUtente.vue?vue&type=template&id=23f570d9&"
import script from "./ReportQuestionariUtente.vue?vue&type=script&lang=js&"
export * from "./ReportQuestionariUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports